<template>
    <div>
        <modal-dialog title="Edit address" @close="cancel" :show="show">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>First Name</label>
                        <input class="form-control" v-model="address.firstname">
                        <ul class="form-errors" v-if="errors['firstname']">
                            <li v-for="error in errors['firstname']">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Last Name</label>
                        <input class="form-control" v-model="address.lastname">
                        <ul class="form-errors" v-if="errors['lastname']">
                            <li v-for="error in errors['lastname']">{{ error }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Country</label>
                <country-select v-model="address.country.name" v-if="show"></country-select>
                <ul class="form-errors" v-if="errors['country']">
                    <li v-for="error in errors['country']">{{ error }}</li>
                </ul>
            </div>
            <div class="form-group">
                <label>Postcode</label>
                <input class="form-control" v-model="address.postal_code">
                <ul class="form-errors" v-if="errors['postal_code']">
                    <li v-for="error in errors['postal_code']">{{ error }}</li>
                </ul>
            </div>
            <div class="form-group">
                <label>Address</label>
                <input class="form-control" v-model="address.address"><br>
                <input class="form-control" v-model="address.address_two"><br>
                <input class="form-control" v-model="address.address_three">

                <ul class="form-errors" v-if="errors['address']">
                    <li v-for="error in errors['address']">{{ error }}</li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Town/City</label>
                        <input class="form-control" v-model="address.city">
                        <ul class="form-errors" v-if="errors['city']">
                            <li v-for="error in errors['city']">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>County</label>
                        <input class="form-control" v-model="address.state">
                        <ul class="form-errors" v-if="errors['state']">
                            <li v-for="error in errors['state']">This field is required</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="row">
                    <div class="col-md-6">
                        <button class="btn btn-red" @click="cancel">Cancel</button>
                    </div>
                    <div class="col-md-6 text-right">
                        <button class="btn" :class="{'btn-green' : saved, 'btn-blue': !saved }" @click="save" :disabled="saving">
                            <template v-if="saving">
                                <i class="fa fa-refresh fa-spin"></i> Saving
                            </template>
                            <template v-else>
                                Save Address
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from '../Elements/ModalDialog.vue';
    import Address from '../../Services/Account/Address.js';

    export default {
        props: {
            id: {
                type: String,
                default: null
            },
            billing: {
                type: Boolean,
                default: false
            },
            address: {
                type: Object,
                default() {
                    return {
                        firstname: '',
                        lastname: '',
                        address: '',
                        address_two: '',
                        address_three: '',
                        city: '',
                        state: '',
                        country: '',
                        postal_code: ''
                    }
                }
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ModalDialog
        },
        data() {
            return {
                errors: [],
                saving: false,
                saved: false,
                changes: {
                    firstname: this.address.firstname,
                    lastname: this.address.lastname,
                    address: this.address.address,
                    address_two: this.address.address_two,
                    address_three: this.address.address_three,
                    city: this.address.city,
                    state: this.address.state,
                    country: this.address.country,
                    postal_code: this.address.postal_code
                }
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel', this.address);
            },
            save() {
                this.saving = true;
                this.errors = [];
                let service = Address.set(this.address);

                if (this.id) {
                    service.for(this.id);
                } else if (this.billing) {
                    this.address.billing = true;
                } else {
                    this.address.shipping = true;
                }

                service.save().then(response => {
                    this.$notify({
                        text: 'Address updated',
                        type: 'success'
                    });
                    this.saving = false;
                    this.$emit('saved', response.data.data);
                }).catch(errors => {
                    this.errors = errors.errors;
                    this.saving = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Account/AccountAddressModal.vue